module.exports = {"56x41": __webpack_public_path__ + "images/explosion-41x56.png"};